import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { EnterprisesService } from 'services/enterprises';
import { useEnterpriseId } from 'stores/user';
import { type EnterpriseActivityItem } from 'types/enterprises';

const DEFAULT_ACTIVITY_LIMIT = 5;

export const useEnterpriseActivity = (
  limit: number = DEFAULT_ACTIVITY_LIMIT
): UseQueryResult<EnterpriseActivityItem[]> => {
  const enterpriseId = useEnterpriseId();

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_ACTIVITY, enterpriseId, limit],
    queryFn: () => EnterprisesService.getActivity(enterpriseId, { limit }),
    select: response => response.data,
    enabled: !!enterpriseId,
  });
};
